import React from "react";

const partnerBanks = [
  "Canara Bank",
  "Union Bank of India",
  "Punjab Gramin Bank",
  "Indian Bank",
];

const refinancingItems = [
  "The beneficiary will be charged the interest rate applicable under the respective NMDFC loan scheme, subject to the scheme guidelines.",
  "Any excess interest amount paid by the beneficiary to the bank prior to the loan being covered under NMDFC refinancing shall be adjusted against the outstanding principal amount of the loan, as per the applicable refinancing guidelines.",
];

const RefinancingThroughBanksContent = () => {
  return (
    <div className="space-y-4 text-[#333333]">
      <section className="space-y-3">
        <h2 className="text-lg font-bold text-[#183967]">
          Refinancing Facility
        </h2>
        <p className="text-justify text-[15px] leading-[1.75] text-[#111827]">
          Beneficiaries seeking financial assistance under the NMDFC Loan
          Schemes are required to apply for loans through the following partner
          banks under the Refinancing Mode:
        </p>
        <ul className="ml-6 list-disc space-y-1.5 text-[15px] leading-[1.65] text-[#111827]">
          {partnerBanks.map((bank) => (
            <li key={bank}>{bank}</li>
          ))}
        </ul>
        <p className="text-justify text-[15px] leading-[1.75] text-[#111827]">
          Loan applications will be processed by the respective bank in
          accordance with its eligibility and sanction norms. Once the loan is
          sanctioned and the beneficiary is found eligible under the applicable
          NMDFC Scheme, the loan will be refinanced by NMDFC through the partner
          bank.
        </p>
        <p className="text-justify text-[15px] leading-[1.75] text-[#111827]">
          After the loan is brought under the NMDFC refinancing arrangement:
        </p>
        <ul className="ml-6 list-disc space-y-1.5 text-[15px] leading-[1.65] text-[#111827]">
          {refinancingItems.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
        <p className="text-justify text-[15px] font-bold italic leading-[1.75] text-[#111827]">
          Note: Refinancing is subject to the beneficiary fulfilling the
          eligibility criteria prescribed by NMDFC and the participating bank,
          as well as the availability of funds under the respective scheme.
        </p>
      </section>
    </div>
  );
};

export default RefinancingThroughBanksContent;
